import React from 'react';
import { Chip } from 'components/mui';
import { CommentFilter } from '../../hooks/useCommentsDashboard';
import { CustomerOption } from 'api/cases/searchCustomers';
import { ConsultantOption } from 'api/cases/searchConsultants';

interface CommentFilterChipsProps {
	selectedCustomer: CustomerOption | null;
	selectedConsultant: ConsultantOption | null;
	dateValue: string;
	onClear: (field: keyof CommentFilter) => void;
}

function CommentFilterChips({
	selectedCustomer,
	selectedConsultant,
	dateValue,
	onClear,
}: CommentFilterChipsProps) {
	const chipSx = {
		height: 24,
		fontSize: '0.75rem',
		fontWeight: 500,
		'& .MuiChip-deleteIcon': { fontSize: 14 },
	};

	return (
		<>
			{selectedCustomer && (
				<Chip
					label={`Customer: ${selectedCustomer.Name}`}
					size="small"
					onDelete={() => onClear('CustomerId')}
					color="default"
					variant="outlined"
					sx={chipSx}
				/>
			)}
			{selectedConsultant && (
				<Chip
					label={`Consultant: ${selectedConsultant.FullName}`}
					size="small"
					onDelete={() => onClear('ConsultantId')}
					color="default"
					variant="outlined"
					sx={chipSx}
				/>
			)}
			{dateValue && (
				<Chip
					label={`Date: ${dateValue}`}
					size="small"
					onDelete={() => onClear('Date')}
					color="default"
					variant="outlined"
					sx={chipSx}
				/>
			)}
		</>
	);
}

export default CommentFilterChips;
